const isCart = window.location.href.includes("/cart");
const isRegister = window.location.href.includes("/account/register") || window.location.href.includes("/pages/inscription");

function getTermsCheckboxForCheckoutButton(checkoutButton) {
  const isInDrawer = checkoutButton.closest('cart-drawer');
  return isInDrawer ? document.querySelector('#CartTerms-Drawer') : document.querySelector('#CartTerms');
}

function validateCheckout() {
  const checkoutButtons = document.querySelectorAll('[name="checkout"]');
  checkoutButtons.forEach((checkoutButton) => {
    const footer = checkoutButton.closest('.cart-drawer-footer');
    const form = footer ? footer.querySelector('.zip-code-form__form') : null;
    const termsCheckbox = getTermsCheckboxForCheckoutButton(checkoutButton);

    if (!checkoutButton) return;
    if (!form) {
      return;
    }
    const hasRates = form.getAttribute('data-has-rates') === 'true';
    const termsChecked = termsCheckbox ? termsCheckbox.checked : true;

    if (hasRates && termsChecked) {
      checkoutButton.removeAttribute('disabled');
    } else {
      checkoutButton.setAttribute('disabled', 'true');
    }
  });
}

function bindEvents() {
  const termsCheckboxes = document.querySelectorAll('#CartTerms, #CartTerms-Drawer');
  termsCheckboxes.forEach((el) => {
    el.removeEventListener('change', validateCheckout);
    el.addEventListener('change', validateCheckout);
  });

  document.querySelectorAll('.zip-code-form__form').forEach((form) => {
    form.removeEventListener('zip-code-form-update', validateCheckout);
    form.addEventListener('zip-code-form-update', validateCheckout);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const checkoutButton = document.querySelector('[name="checkout"]');
  bindEvents();
  validateCheckout();

  const bindZipFormAfterCartDomUpdate = () => {
    bindEvents();
    validateCheckout();
  };

  document.addEventListener('line-item:change:end', () => {
    setTimeout(bindZipFormAfterCartDomUpdate, 0);
    setTimeout(bindZipFormAfterCartDomUpdate, 200);
    setTimeout(bindZipFormAfterCartDomUpdate, 1200);
  });

  document.addEventListener('cart:refresh', () => {
    setTimeout(bindZipFormAfterCartDomUpdate, 0);
    setTimeout(bindZipFormAfterCartDomUpdate, 200);
    setTimeout(bindZipFormAfterCartDomUpdate, 1200);
  });

  document.addEventListener('cart-drawer:open', () => {
    setTimeout(validateCheckout, 0);
    setTimeout(validateCheckout, 150);
    setTimeout(validateCheckout, 400);
  });

  const checkButtonClassInterval = setInterval(() => {
    if (checkoutButton?.hasAttribute('bss-b2b-cart-trigger-added')) {
      setTimeout(() => {
        validateCheckout();
      },500)
      clearInterval(checkButtonClassInterval);
    }
  }, 300);

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('active')
        ) {
          setTimeout(() => {
            bindEvents();
            validateCheckout();
          }, 0);
          setTimeout(() => {
            validateCheckout();
          }, 150);
          setTimeout(() => {
            validateCheckout();
          }, 400);
        }
        if (
          mutation.type === 'childList' &&
          mutation.target.classList.contains('cart-drawer')
        ) {
          setTimeout(() => {
            bindEvents();
            validateCheckout();
          }, 100);
        }
        if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style' &&
            mutation.target.classList.contains('checkout-button')
        ) {
          setTimeout(() => {
            bindEvents();
            validateCheckout();
          }, 0);
        }
        if (
          mutation.type === 'childList' &&
          mutation.target.classList.contains('cart__subtotal-price')
        ) {
          setTimeout(() => {
            bindEvents();
            validateCheckout();
          }, 100);
        }
      }
    });

    observer.observe(cartDrawer, { 
      attributes: true,
      childList: true,
      subtree: true 
    });

    const checkoutButtonObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          const btn = mutation.target;
          if (btn.matches('[name="checkout"]') && !btn.hasAttribute('disabled')) {
            const footer = btn.closest('.cart-drawer-footer');
            const form = footer ? footer.querySelector('.zip-code-form__form') : null;
            if (form && form.getAttribute('data-has-rates') !== 'true') {
              btn.setAttribute('disabled', 'true');
            }
          }
        }
      }
    });

    const observeCheckoutButtons = () => {
      document.querySelectorAll('[name="checkout"]').forEach((btn) => {
        if (!btn.dataset.checkoutObserved) {
          btn.dataset.checkoutObserved = '1';
          checkoutButtonObserver.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
        }
      });
    };

    observeCheckoutButtons();
    document.addEventListener('cart-drawer:open', observeCheckoutButtons);
    setTimeout(observeCheckoutButtons, 1000);
  }

  if (isRegister) {
    setTimeout(() => {
      var countryField = document.getElementById('country-field');
      var countryName = document.getElementById('country-name');
      if (countryField && countryName) {
        countryField.value = 'FR';
        countryName.value = 'France';
      }
    }, 2000);
  }

  if (window.location.pathname === "/pages/inscription") {
    const RfFormInterval = setInterval(() => {
      const RfFormContent = document.querySelector('.bss-b2b-registration-form-content');
      if (RfFormContent) {
        const submitBtn = document.querySelector(".bss-b2b-rf-submit-button");

      const infoText = document.createElement("p");
      infoText.classList.add("bss-b2b-grid-col-3")
      infoText.innerHTML = `
        Les données recueillies dans ce formulaire sont traitées afin de
        répondre à votre demande et assurer son suivi. Pour en savoir plus sur la
        gestion de vos données et vos droits, consultez notre <a href="https://twood.fr/policies/privacy-policy" target="_blank" style="color: blue; text-decoration: underline;">
          politique de confidentialité
        </a>.
      `;
      infoText.style.fontSize = "14px";
      infoText.style.margin = "10px 0";

      submitBtn.parentNode.insertBefore(infoText, submitBtn);


        clearInterval(RfFormInterval); 
      }
    }, 300); 
  }

});
